import React, { memo, useCallback, useMemo, useState } from "react";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

import { GENERATE_BILL_CONSTANTS, IMAGES } from "./constant";
import { ButtonContainer, FlexCta, HeadingTitleContainer, DescriptionContainer } from "./styled";
import { IGenerateBillContentProps, IGenerateBillCTA } from "./types";

const GenerateBillContent = memo(({ onPrimaryAction }: IGenerateBillContentProps) => {
    const [isLoading, setIsLoading] = useState(false);

    const handlePrimaryAction = useCallback(() => {
        setIsLoading(true);
        onPrimaryAction();
    }, [onPrimaryAction]);

    const ctas: IGenerateBillCTA[] = useMemo(
        () => [
            {
                text: GENERATE_BILL_CONSTANTS.PRIMARY_BUTTON_TEXT,
                buttonType: "primary",
                onClick: handlePrimaryAction,
            },
        ],
        [handlePrimaryAction]
    );

    return (
        <>
            <Image
                src={IMAGES.BILL_PAYMENT}
                alt={GENERATE_BILL_CONSTANTS.IMAGE_ALT}
                cloudinaryHeight={GENERATE_BILL_CONSTANTS.ICON_SIZE * 2}
                cloudinaryWidth={GENERATE_BILL_CONSTANTS.ICON_SIZE * 2}
                height={String(GENERATE_BILL_CONSTANTS.ICON_SIZE)}
                width={String(GENERATE_BILL_CONSTANTS.ICON_SIZE)}
            />

            <HeadingTitleContainer>
                <Text variant="V2.heading1.neutral.bold" color="text_Highest_Emphasis">
                    {GENERATE_BILL_CONSTANTS.TITLE}
                </Text>
            </HeadingTitleContainer>

            <DescriptionContainer>
                <Text variant="V2.body1.neutral.regular" color="text_Med_Emphasis">
                    {GENERATE_BILL_CONSTANTS.DESCRIPTION}
                </Text>
            </DescriptionContainer>

            <ButtonContainer>
                {ctas?.map((cta) => (
                    <FlexCta key={cta?.text}>
                        <SuperButton
                            buttonType={cta.buttonType || "primary"}
                            buttonSize="large"
                            onClick={cta.onClick}
                            loading={isLoading}
                        >
                            {cta.text}
                        </SuperButton>
                    </FlexCta>
                ))}
            </ButtonContainer>
        </>
    );
});

GenerateBillContent.displayName = "GenerateBillContent";

export default GenerateBillContent;
